
import { ComputedOneOffPricing } from "@/models/payment/computed-one-off-pricing";
import { printHumanFloat } from "@/utils/pretty-print";
import Vue from "vue";
import AppPayRow from "./ActivationCardPayRow.vue";

export default Vue.extend({
	filters: {
		printHumanFloat,
	},
	props: {
		pricing: {
			type: Object as () => ComputedOneOffPricing,
			required: true
		}
	},
	computed: {
		price(): number {
			return this.pricing.price;
		},
		hasVat(): boolean {
			return this.pricing.vatPercent != 0;
		},
		vat(): number {
			return this.pricing.vat;
		},
		vatPercent(): number {
			return this.pricing.vatPercent;
		},
		priceWithVat(): number {
			return this.pricing.total;
		},
		discount(): number {
			return this.pricing.discountPercent;
		},
		prettyDiscount(): string {
			return printHumanFloat(this.pricing.discountPercent, 0);
		}

	},
	components: {
		AppPayRow
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
